<template>
    <div>
        <button
            type="button"
            :class="btnClasses"
            @click="$modal.show('create-mailshot')"
        >
            Nytt utskick
        </button>
        <adaptive-form-modal
            name="create-mailshot"
            primary-button-text="Skapa utskick"
            primary-button-class="is-primary"
            title="Skapa utskick"
            :action="action"
        >
            <text-input
                v-model="subject"
                name="subject"
                label="Ämne"
                :required="true"
                :autofocus="true"
            />
            <checkbox-input
                v-model="isExternal"
                :value="isExternalBinary"
                name="isExternal"
                class="form-input"
                style="border: none;"
            >
                Registrera som externt utskick
            </checkbox-input>
            <text-input
                :style="{border: 'none', visibility: isExternal ? 'visible' : 'hidden'}"
                label="Datum"
                type="date"
                name="date"
                :value="date"
                :required="isExternal"
            />
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            action: {
                type: String,
                required: true,
            },
            btnClasses: {
                type: String,
                default: 'btn btn-md is-primary',
            },
        },
        data() {
            return {
                date: null,
                isExternal: null,
                subject: null,
            };
        },
        computed: {
            isExternalBinary() {
                return this.isExternal ? 1 : 0;
            },
        },
    };
</script>
